<div class="password-strength">
    <label for="passwordStrength">Passwortstärke</label>
    <mat-progress-bar mode="determinate" id="passwordStrength" [value]="passwordStrength"></mat-progress-bar>
</div>